import { call, put, takeLatest } from "redux-saga/effects";
import fetchAPI, { ApiResponse, HttpMethod } from "../../../utils/api";
import { showSuccess } from "../../toaster/store/slice";
import profilePageSlice from "./slice";
import { fetchProfile } from "../../login-page/store/saga";
import loginPageSlice from "../../login-page/store/slice";

type ToggleNotificationsResponse = ApiResponse<{ success: true }>;
type DeleteResponse = ApiResponse<{ success: true }>;

function* profilePageSaga() {
  yield takeLatest(
    profilePageSlice.actions.toggleNotifications,
    handleNotificationToggle
  );
  yield takeLatest(profilePageSlice.actions.deleteProfile, handleDelete);
}

function* handleNotificationToggle() {
  const response: ToggleNotificationsResponse = yield call(
    fetchAPI,
    `/profile/toggle-notifications`,
    {
      method: HttpMethod.POST,
    }
  );

  if (response && response.success) {
    yield call(fetchProfile);

    yield put(showSuccess("Notification settings adjusted."));
  }
}

function* handleDelete() {
  const response: DeleteResponse = yield call(fetchAPI, `/profile`, {
    method: HttpMethod.DELETE,
  });

  if (response && response.success) {
    yield put(loginPageSlice.actions.logout());

    yield put(showSuccess("Account deleted."));
  }
}

export default profilePageSaga;
